import { Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { Loading } from '../../../../general/components/loading';
import { TerminalWizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { ConfirmCheck } from '../../../../theme/coast/icons';
import { VerifyAnotherCompanyButton } from '../../../fleet-verification/components/verify-another-company-button';

const selector = ({ nextStep: { loading } }: RootState) => ({
  loading,
});

const VerificationOfflineReviewPage: FC = () => {
  const { loading } = useSelector(selector);

  return (
    <TerminalWizardPage
      icon={<ConfirmCheck />}
      title="That's all for now!"
      subtext={<>We are reviewing your information.</>}
    >
      <Loading open={loading} />
      <Typography variant="inherit" align="center" color="textSecondary">
        We will send you an email as soon as we&apos;ve
        <br />
        finished verifying your info.
      </Typography>
      <VerifyAnotherCompanyButton />
    </TerminalWizardPage>
  );
};

export { VerificationOfflineReviewPage };
